import React, { Component } from 'react'

import mapStyles from './map.module.scss'

class Map extends Component {
  render() {
    const { className, points, clickPoint } = this.props
    return (
      <>
        <svg
          version="1.1"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 477.7 569.1"
        >
          <filter id="double">
            <feMorphology
              in="SourceGraphic"
              result="a"
              operator="dilate"
              radius="1"
            />
            <feComposite
              in="SourceGraphic"
              in2="a"
              result="xx"
              operator="xor"
            />
          </filter>
          <g>
            <path
              className={mapStyles.st0}
              d="M341.5,2.2c1.7,0.6,56.7,113.5,56.7,113.5c0.9,1.8,2.7,4.6,4.1,6.1l4.9,5.4c1.4,1.5,2.9,4.4,3.4,6.3l6.8,25.7
		c0.5,2,0.4,5.1-0.2,7.1l-1.8,5.6c-0.6,1.9,0.3,4.4,1.9,5.6l57.2,38.5c1.7,1.1,3.1,3.7,3.1,5.7v0.1c0,2-1,5-2.3,6.6l-71.4,88.1
		c-1.3,1.6-2.4,4.5-2.5,6.6l-1.5,41c-0.1,2,0.5,5.2,1.3,7.1l2.9,7c0.8,1.9,0.1,4.4-1.5,5.6l-10.8,8.2c-1.6,1.2-4.6,2.2-6.6,2.2h-5.3
		c-2,0-4.9,1.1-6.4,2.5l-10.1,9.4c-1.5,1.4-3.4,4-4.3,5.8l-6.1,12.9c-0.9,1.8-2.7,4.5-4.2,5.9l-8.6,8.6c-1.4,1.4-4.1,1.8-5.8,0.8
		l-13.1-7.3c-1.8-1-4.8-1.4-6.8-0.8l-10.2,2.7c-2,0.5-4.6,2.3-5.8,3.9l-30.7,40.8c-1.2,1.6-2.5,4.6-2.7,6.6l-1.3,8.8
		c-0.3,2-2.2,3.5-4.2,3.2l-2.5-0.3c-2-0.2-4.5,1-5.4,2.8l-3.4,6.2c-1,1.8-3.4,3.5-5.4,3.9l-8.3,1.5c-2,0.4-5.2,0.1-7.1-0.5
		l-20.1-6.8c-1.9-0.7-4.7-2.4-6.1-3.8l-5.2-5.2c-1.4-1.4-4.3-2.5-6.3-2.4l-5.3,0.2c-2,0.1-4.3,1.7-5.2,3.5l-12.3,28.3
		c-0.8,1.9-3.1,3.1-5.1,2.9c-2-0.3-3.9,1.1-4.3,3.1l-0.6,3.5c-0.4,2-2.2,4.3-4,5.2l-21.4,9.7c-1.8,0.8-5,1.4-7,1.2l-4.2-0.4
		c-2-0.2-5.3,0.1-7.2,0.6l-2.8,0.7c-2,0.5-4.6,2.2-5.9,3.8l-10.2,12.7"
            />
          </g>
          <g>
            <path
              className={mapStyles.st0}
              d="M262.6,169.4l-5.5,26.1c-0.4,2-0.2,5.2,0.5,7.1l3.2,8.6c0.7,1.9,2.5,4.5,4.1,5.8l9.3,7.9c1.5,1.3,3,4,3.3,6
		l3,22.6c0.3,2,1.4,5,2.5,6.7l9.7,14.6c1.1,1.7,2,4.7,2,6.8v15.1c0,2,1.4,4.6,3.1,5.7l7.1,4.6c1.7,1.1,3.5,3.6,3.9,5.6l4.6,19.3
		c0.5,2,2.2,4.6,3.8,5.8l18.9,14.5c1.6,1.2,3.6,3.7,4.5,5.6l13.5,27.9c0.9,1.8,2.4,4.8,3.3,6.6l9.8,18.8c0.9,1.8,1.3,4.9,0.9,6.9
		l-7,29.7c-0.5,2-0.4,5.2,0.2,7.1l10.5,34.4c0.6,1.9,0.3,5-0.7,6.8l-10.4,19.4c-1,1.8-3.1,4.3-4.7,5.5l-17.7,13.4
		c-1.6,1.2-3.4,3.8-4,5.8l-8.7,28.7"
            />
          </g>
          <g>
            <path
              className={mapStyles.st0}
              d="M153.8,435.8l16.5-1.9c2-0.2,4.8-1.6,6.2-3.1c0,0,18.2-19.2,21.1-19.8c2.9-0.6,15.9-2.8,15.9-2.8
		c2-0.3,5.1-1.4,6.9-2.3c0,0,15.1-7.6,17.4-6.4c2.3,1.2,29.2,3.2,29.2,3.2c2,0.2,3.8,1.9,3.9,4l0.8,13.9c0.1,2,1.6,4.6,3.3,5.7
		l11.7,8c1.7,1.1,4.7,2,6.7,1.9l7.3-0.4"
            />
          </g>
          <g>
            <path
              className={mapStyles.st0}
              d="M159.7,246l-13.6-7.2c-1.8-0.9-4.9-1.3-6.8-0.8l-29.1,7.4c-2,0.5-3,2.5-2.4,4.4l3.4,10.3
		c0.6,1.9-0.1,4.6-1.7,5.8l-4.1,3.4c-1.6,1.3-4.5,2.2-6.5,2.1l-9.9-0.7c-2-0.1-5.2-1-7-1.8l-5.4-2.6c-1.8-0.9-5-1.8-7-2l-50.7-5.1
		c-2-0.2-4.6,1-5.8,2.6L0.2,280.2"
            />
          </g>
          <g>
            <path
              className={mapStyles.st0}
              d="M316.2,73l-3.9-0.9c-2-0.5-4.7,0.4-6.1,1.9l-7.7,8.4c-1.4,1.5-3.2,4.2-4,6.1l-7.8,16.9c-0.9,1.8-1,4.9-0.4,6.9
		l1.8,5.6c0.6,1.9-0.1,4.7-1.5,6.1l-21.3,21.3c-1.4,1.4-3.9,3.6-5.5,4.9c0,0-19,15-20.7,15s-15.9,0-15.9,0c-2,0-4.9-1.1-6.5-2.4
		l-10.5-9c-1.5-1.3-4.5-2.3-6.5-2.2l-11.1,0.7c-2,0.1-5.3,0.2-7.4,0.1l-27.8-0.9c-2-0.1-5.3-0.6-7.2-1.1l-21.1-6
		c-1.9-0.6-5-0.2-6.7,0.9l-8.1,4.8c-1.7,1-4.8,1.5-6.8,1.1l-5.5-1.2c-2-0.4-5.2-0.5-7.2-0.2L63,154.2c-2,0.3-4.7-0.7-5.9-2.3
		l-13.3-16.7"
            />
          </g>
          <g className="river">
            <polyline
              id="base"
              className={mapStyles.water}
              points="357.3,2.5 338.3,45.6 333.7,57.7 321,62.3 311.7,81.6 316,90.8 299.4,128.9 287.1,132.3 
	278.4,147.6 264.3,150.2 262.3,168.4 236.7,180.1 228.5,194.5 202.1,210.9 183.2,215.2 161.4,248.2 131.5,252.3 127.1,255.9 
	120.9,293.8 126.4,306.8 123.5,319.6 128.9,346 123.5,356 112.8,356.2 116.4,370.1 123,400 132.8,403.1 132.2,412.8 153.5,430 
	153,448.1 160.1,448.9 160.1,460.2 175.2,471.2 178.8,488.6 172.2,489.1 163.7,505.5 168.1,509.8 159.9,522.1 150.9,521.1 
	145,544.9 "
            />
            <polyline
              className={mapStyles.grid}
              filter="url(#double)"
              points="357.3,2.5 338.3,45.6 333.7,57.7 321,62.3 311.7,81.6 316,90.8 299.4,128.9 287.1,132.3 
	278.4,147.6 264.3,150.2 262.3,168.4 236.7,180.1 228.5,194.5 202.1,210.9 183.2,215.2 161.4,248.2 131.5,252.3 127.1,255.9 
	120.9,293.8 126.4,306.8 123.5,319.6 128.9,346 123.5,356 112.8,356.2 116.4,370.1 123,400 132.8,403.1 132.2,412.8 153.5,430 
	153,448.1 160.1,448.9 160.1,460.2 175.2,471.2 178.8,488.6 172.2,489.1 163.7,505.5 168.1,509.8 159.9,522.1 150.9,521.1 
	145,544.9 "
            />
            <polyline
              className={mapStyles.middle}
              points="357.3,2.5 338.3,45.6 333.7,57.7 321,62.3 311.7,81.6 316,90.8 299.4,128.9 287.1,132.3 
	278.4,147.6 264.3,150.2 262.3,168.4 236.7,180.1 228.5,194.5 202.1,210.9 183.2,215.2 161.4,248.2 131.5,252.3 127.1,255.9 
	120.9,293.8 126.4,306.8 123.5,319.6 128.9,346 123.5,356 112.8,356.2 116.4,370.1 123,400 132.8,403.1 132.2,412.8 153.5,430 
	153,448.1 160.1,448.9 160.1,460.2 175.2,471.2 178.8,488.6 172.2,489.1 163.7,505.5 168.1,509.8 159.9,522.1 150.9,521.1 
	145,544.9 "
            />
          </g>
          <g id="points">
            <g
              data-slide="1"
              id="p11"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p11') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M383,302.1c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C392.4,306.3,388.2,302.1,383,302.1z"
                />
                <circle className={mapStyles.st3} cx="383" cy="310.9" r="2.7" />
              </g>
            </g>
            <g
              data-slide="2"
              id="p10"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p10') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M146.3,524.5c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C155.8,528.7,151.6,524.5,146.3,524.5z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="146.3"
                  cy="533.3"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="3"
              id="p9"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p9') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M153.3,412.2c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C162.7,416.4,158.5,412.2,153.3,412.2z"
                />
                <circle className={mapStyles.st3} cx="153.3" cy="421" r="2.7" />
              </g>
            </g>
            <g
              data-slide="4"
              id="p8"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p8') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M130.1,392.5c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C139.5,396.8,135.3,392.5,130.1,392.5z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="130.1"
                  cy="401.4"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="5"
              id="p7"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p7') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M151.5,223.4c-5.2,0-9.4,4.2-9.4,9.4s9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6S156.7,223.4,151.5,223.4z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="151.5"
                  cy="232.3"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="6"
              id="p6"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p6') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M230.7,161.1c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C240.1,165.4,235.9,161.1,230.7,161.1z"
                />
                <circle className={mapStyles.st3} cx="230.7" cy="170" r="2.7" />
              </g>
            </g>
            <g
              data-slide="7"
              id="p5"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p5') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M244.3,175c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C253.7,179.2,249.5,175,244.3,175z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="244.3"
                  cy="183.8"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="8"
              id="p4"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p4') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M261.1,128.4c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C270.5,132.6,266.3,128.4,261.1,128.4z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="261.1"
                  cy="137.2"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="9"
              id="p3"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p3') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M301,120.7c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C310.4,124.9,306.2,120.7,301,120.7z"
                />
                <circle className={mapStyles.st3} cx="301" cy="129.5" r="2.7" />
              </g>
            </g>
            <g
              data-slide="10"
              id="p2"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p2') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M317,72.2c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6
				C326.4,76.4,322.2,72.2,317,72.2z"
                />
                <circle className={mapStyles.st3} cx="317" cy="81" r="2.7" />
              </g>
            </g>
            <g
              data-slide="11"
              id="p1"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p1') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M338.1,46.9c-5.2,0-9.4,4.2-9.4,9.4s9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6S343.3,46.9,338.1,46.9z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="338.1"
                  cy="55.8"
                  r="2.7"
                />
              </g>
            </g>
            <g
              data-slide="12"
              id="p0"
              onClick={clickPoint}
              className={`${mapStyles.point} ${
                points.indexOf('p0') > -1 ? mapStyles.point__on : ''
              }`}
            >
              <g>
                <path
                  className={mapStyles.st2}
                  d="M326.8,36.6c-5.2,0-9.4,4.2-9.4,9.4s9.4,16.6,9.4,16.6s9.4-11.4,9.4-16.6S332,36.6,326.8,36.6z"
                />
                <circle
                  className={mapStyles.st3}
                  cx="326.8"
                  cy="45.4"
                  r="2.7"
                />
              </g>
            </g>
          </g>
          <g id="labels">
            <rect
              x="319"
              y="284.2"
              className={mapStyles.xst0}
              width="51.6"
              height="15"
            />
            <text transform="matrix(1 0 0 1 318.9949 288.7028)">
              <tspan
                x="0"
                y="0"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                SÃO PEDRO{' '}
              </tspan>
              <tspan
                x="0"
                y="8.6"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                DA GRAÇA
              </tspan>
            </text>
            <rect
              x="405.9"
              y="305.8"
              className={mapStyles.xst0}
              width="51.6"
              height="15"
            />
            <text transform="matrix(1 0 0 1 405.947 310.2946)">
              <tspan
                x="0"
                y="0"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                CAPITÃO{' '}
              </tspan>
              <tspan
                x="0"
                y="8.6"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                ENÉAS
              </tspan>
            </text>
            <rect
              x="425.7"
              y="363.1"
              className={mapStyles.xst0}
              width="51.6"
              height="15"
            />
            <text transform="matrix(1 0 0 1 425.7458 367.6051)">
              <tspan
                x="0"
                y="0"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                FRANCISCO{' '}
              </tspan>
              <tspan
                x="0"
                y="8.6"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                ENÉAS
              </tspan>
            </text>
            <rect
              x="272.3"
              y="173.1"
              className={mapStyles.xst0}
              width="71.9"
              height="16"
            />
            <text transform="matrix(1 0 0 1 272.324 177.6539)">
              <tspan
                x="0"
                y="0"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                PEDRAS DE{' '}
              </tspan>
              <tspan
                x="0"
                y="8.6"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                MARIA DA CRUZ
              </tspan>
            </text>
            <rect
              x="171.7"
              y="533.4"
              className={mapStyles.xst0}
              width="71.9"
              height="16"
            />
            <text
              transform="matrix(1 0 0 1 171.7454 537.943)"
              className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
            >
              BURITIZEIRO
            </text>
            <g>
              <rect
                x="42.6"
                y="224.2"
                className={mapStyles.xst0}
                width="100.4"
                height="16"
              />
              <text
                transform="matrix(1 0 0 1 42.6311 230.4401)"
                className={`${mapStyles.xst4} ${mapStyles.xst2} ${mapStyles.xst5}`}
              >
                São Francisco
              </text>
            </g>
            <rect
              x="80"
              y="473.3"
              className={mapStyles.xst0}
              width="71.9"
              height="16"
            />
            <text transform="matrix(1 0 0 1 79.9656 477.7936)">
              <tspan
                x="0"
                y="0"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                CACHOEIRA{' '}
              </tspan>
              <tspan
                x="0"
                y="8.6"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                DO MANTEIGA
              </tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 254.8445 65.3932)"
              className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
            >
              Itacarambi
            </text>
            <text
              transform="matrix(1 0 0 1 207.7166 137.1178)"
              className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
            >
              Januária
            </text>
            <text
              transform="matrix(1 0 0 1 216.8855 325.1813)"
              className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
            >
              JAPONVAR
            </text>
            <g>
              <text
                transform="matrix(1 0 0 1 133.8787 382.5192)"
                className={`${mapStyles.xst1} ${mapStyles.xst2} ${mapStyles.xst3}`}
              >
                IBIAI
              </text>
            </g>
          </g>
        </svg>
      </>
    )
  }
}

export default Map
